import {DEFAULT_BREAKPOINTS} from "@ngbracket/ngx-layout";


export function OverrideScreenBreakpoints() {


  const SizeBreakpoints = {
    'xs': 525,
    'sm': 775,
    'md': 1280,
    'lg': 1920,
    'xl': 5000
  } as const;

  const maxRegex = /max-width: (\d+(?:\.\d+)?)(px|em|rem|vw|vh)/;
  const minRegex = /min-width: (\d+(?:\.\d+)?)(px|em|rem|vw|vh)/;

  const ascending = Object.entries(SizeBreakpoints).sort((a, b) => a[1] - b[1]);
  // console.log(Object.fromEntries(DEFAULT_BREAKPOINTS.map(bp => [bp.alias, bp.mediaQuery])));

  ascending.forEach(([key, value], i) => {
    const bp = DEFAULT_BREAKPOINTS.find(item => item.alias == key);
    const max = value;
    const min = i > 0 ? SizeBreakpoints[Object.keys(SizeBreakpoints)[i - 1] as keyof typeof SizeBreakpoints] : 0;

    if (!bp) {
      console.warn(`Breakpoint ${key} not found`);
      return;
    }

    const newQuery = max ? bp.mediaQuery.replace(maxRegex, `max-width: ${max - 0.02}px`) : bp.mediaQuery;
    bp.mediaQuery = newQuery.replace(minRegex, `min-width: ${min ?? 0}px`);
    const ltBp = DEFAULT_BREAKPOINTS.find(item => item.alias == `lt-${key}`);
    if (ltBp) {
      ltBp.mediaQuery = ltBp.mediaQuery.replace(maxRegex, `max-width: ${(min ?? 1) - 0.02}px`);
    }
    const gtBp = DEFAULT_BREAKPOINTS.find(item => item.alias == `gt-${key}`);
    if (gtBp) {
      gtBp.mediaQuery = gtBp.mediaQuery.replace(minRegex, `min-width: ${max ?? 1}px`);
    }
  });

  // DEFAULT_BREAKPOINTS.push(...[
  //   {
  //     alias: 'xxs',
  //     mediaQuery: '(max-width: 524px)',
  //     priority: 1100
  //   },
  //   {
  //     alias: 'lt-xs',
  //     overlapping: true,
  //     mediaQuery: 'screen and (max-width: 524.98px)',
  //     priority: 1050
  //   },
  //   {
  //     alias: 'gt-xxs',
  //     overlapping: true,
  //     mediaQuery: 'screen and (min-width: 600px)',
  //     priority: -1050
  //   },
  // ])

  // console.log(Object.fromEntries(DEFAULT_BREAKPOINTS.map(bp => [bp.alias, bp.mediaQuery])));
}
